// firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  browserLocalPersistence,
  setPersistence,
} from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDHPbJuqAaC2BxMIbQJq1uYBIwa3tDe-w8",
  authDomain: "referral-app-aif.firebaseapp.com",
  projectId: "referral-app-aif",
  storageBucket: "referral-app-aif.firebasestorage.app",
  messagingSenderId: "232177179516",
  appId: "1:232177179516:web:498ad231ed7fe921c3a2f9",
  measurementId: "G-SPKVDTCN09",
};

const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LfZc_AqAAAAAOd4qle4rpxXduz-MiufrtTzTS4z"),
  isTokenAutoRefreshEnabled: true,
});
const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // console.log("Persistence set!");
  })
  .catch((error) => {
    // console.error("Error setting persistence:", error);
  });

auth.settings.appVerificationDisabledForTesting = false;

export { app, auth };
